import { FormGroup, Input, Label } from '~/components/unform'

const ProductPage = () => (
  <FormGroup>
    <Label isRequired text="SKU" />
    <Input required name="product_sku" placeholder="Product SKU" />
  </FormGroup>
)

export default ProductPage
